import {
    SET_NAV_INDEX,
    PROJECT_CONFIG,
    HASH_MENUS
} from './mutationTypes.js'
//这里是你要修改state里面的变量的时候用到的方法
const mutations = {
    [SET_NAV_INDEX](state, value) {
        state.navIndex = value;
    },
    //系统级别的常量
    [PROJECT_CONFIG](state, value) {
        state.projectConfig = value
    },
    //有权限的菜单
    [HASH_MENUS](state, value){
        const map = Object.assign({},value)
        let result = {}
        Object.keys(map).forEach(row => {
            result[row.toLowerCase()] = true
        })
        state.hashMenus = result
    }
}
export {
    mutations
}
